<div>
  <nz-form-item>
    <nz-form-label>Monthly Income Goal</nz-form-label>
    <nz-form-control [nzSpan]="24">
      <nz-input-number
        [(ngModel)]="analysisPlan.inputs.monthlyIncomeGoal"
        (ngModelChange)="emitDataChange()"
        [nzFormatter]="formatterDollar"
        [nzParser]="parserDollar"
      ></nz-input-number>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label>Monthly Contribution Amount</nz-form-label>
    <nz-form-control [nzSpan]="24">
      <nz-input-number
        [(ngModel)]="analysisPlan.inputs.monthlyContributionAmount"
        (ngModelChange)="emitDataChange()"
        [nzFormatter]="formatterDollar"
        [nzParser]="parserDollar"
      ></nz-input-number>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control>
      <label
        nz-checkbox
        [(ngModel)]="analysisPlan.inputs.clientAdvanced"
        (ngModelChange)="emitDataChange()"
      >
        <span>Enable Advanced Settings</span>
      </label>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item *ngIf="analysisPlan.inputs.clientAdvanced">
    <nz-form-label>Inflation Rate for Income Goal</nz-form-label>
    <nz-form-control [nzSpan]="24">
      <nz-input-number
        [(ngModel)]="analysisPlan.inputs.inflationRate"
        (ngModelChange)="emitDataChange()"
        [nzMin]="0"
        [nzMax]="100"
        [nzStep]="1"
        [nzFormatter]="formatterPercent"
        [nzParser]="parserPercent"
      ></nz-input-number>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item *ngIf="analysisPlan.inputs.clientAdvanced">
    <nz-form-label>Years to Simulate</nz-form-label>
    <nz-form-control [nzSpan]="24">
      <nz-input-number
        [(ngModel)]="analysisPlan.inputs.yearsToSimulate"
        (ngModelChange)="emitDataChange()"
        [nzMin]="1"
        [nzMax]="100"
        [nzStep]="1"
      ></nz-input-number>
    </nz-form-control>
  </nz-form-item>
</div>
